export default __webpack_public_path__ + "static/media/hp-banner-graphics-mobile.45a7c385.svg";